<style scoped>
    .vue-modal {
        display: block;
    }
</style>

<template>
    <div style="display:inline-block;width:100%">
        <div id="status_changer" v-show="show_status_changer">
            <div class="b-status-changer__box col-md-6 col-xs-6">
                <select class="form-control input-sm" v-model="selected" >
                    <option value="" v-text="trans('choose')"></option>
                    <option v-for="status in statuses" :value="status.code">
                        {{ status.title }}
                    </option>
                </select>
            </div>
            <div class="col-md-6 col-xs-6">
                <button @click="update_statuses()" class="btn btn-primary btn-sm">
                    <span v-show="!show_loader" v-text="trans('update_button', null)"></span>
                    <div class="la-ball-fall" v-show="show_loader"><div></div><div></div><div></div></div>
                </button>
            </div>
        </div>
        <div class="modal modal-danger vue-modal" v-show="show">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" @click="show = false" aria-label="Close">
                            <span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title" v-text="trans('error')"></h4>
                    </div>
                    <div class="modal-body" v-html="errors"></div>
                    <div class="modal-footer">
                        <button type="button"
                                @click="show = false"
                                class="btn btn-danger pull-right"
                                v-text="trans('close_button', null)"
                        ></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import * as Functions from '../Functions';

    export default {
        props: ['current_route', 'translations'],
        mounted: function() {
            Vue.http.headers.common['X-CSRF-TOKEN'] = document.querySelector('#token').getAttribute('content');

            this.get_next_statuses();
        },
        data: function () {
            return {
                show: false,
                show_loader: false,
                show_status_changer: true,
                selected: '',
                checked: [],
                order_numbers: [],
                statuses: [],
                update_lock: false,
                errors: ""
            };
        },
        computed: {
            current_status_code : function()
            {
                let routesArray = this.current_route.split('/');
                return routesArray[routesArray.length - 2] === 'status'
                    ? routesArray[routesArray.length - 1]
                    : '';
            }
        },
        methods: {
            trans(name, path = 'mass_status_changer') {
                return Functions.trans(this.translations, name, path);
            },
            get_next_statuses: function () {
                this.$http.get('/shop/orders/get_statuses/' + this.current_status_code)
                    .then(function (response) {
                        if (response.data.next_statuses.length > 0) {
                            this.statuses = response.data.next_statuses;

                            if (response.data.default_status != null) {
                                this.selected = response.data.default_status;
                            }
                        } else {
                            this.show_status_changer = false;
                        }
                    }, function (response) {
                        console.log(response.data);
                    });
            },
            update_statuses: function () {
                if (this.checked.length == 0) {
                    return this.orders_not_found();
                }
                if (this.selected == "") {
                    return this.status_is_not_selected();
                }
                if (!this.confirmChanges()) {
                    return;
                }
                this.show_loader = true;

                if(this.update_lock === false) {
                    this.update_lock = true;
                    this.$http.post('/shop/orders/change_statuses', {ids: this.checked, new_status_code: this.selected})
                        .then((response) => {
                            if (response.data.errors) {
                                this.show_errors(response.data.errors);
                            }

                            this.checked = [];
                            this.all_selected = false;
                            this.$root.$emit('update-table');
                            this.show_loader = false;
                            this.update_lock = false;
                            document.getElementsByClassName('b-admin-statuses__list')[0].innerHTML = response.data.statuses;
                        }, function (response) {
                            alert(response.data.message);
                        });
                }
            },
            confirmChanges: function () {
                if (this.selectedCanceledStatus() && this.checked.length >= 30) {
                    return confirm(this.trans('warning_try_cancel').replace(':orders', this.checked.length));
                }

                if (this.selectedReturnedStatus()) {
                    return confirm(this.trans('warning_try_return'));
                }

                return true;
            },
            selectedCanceledStatus: function () {
                return this.selected === this.getCanceledStatusCode();
            },
            getCanceledStatusCode: function () {
                return 'canceled';
            },
            selectedReturnedStatus: function () {
                return this.selected === this.getReturnedStatusCode();
            },
            getReturnedStatusCode: function () {
                return 'return';
            },
            show_errors: function (errors) {
                this.errors = errors;
                this.show = true;
            },
            orders_not_found: function () {
                alert(this.trans('orders_not_selected', null));
            },
            status_is_not_selected: function () {
                alert(this.trans('status_not_selected'));
            },
            changeStatusEventHandler: function (data) {
                this.checked = [data.order_id];
                this.selected = data.status_code;
                this.update_statuses();
            }
        },
        //EVENTS
        created: function () {
            this.$root.$on('change-status', this.changeStatusEventHandler);
            this.$root.$on('update:checked', (val) => {this.checked = val});
            this.$root.$on('update:order_numbers', (val) => {this.order_numbers = val});
        },
        beforeDestroy: function () {
            this.$root.$off('change-status', this.changeStatusEventHandler);
        }
    }
</script>
